import { useEffect, useState } from "react";
import axios from "axios";
import { Mail, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";

const LABELS = { pending: "Pending", sending: "Submitting", accepted: "Submitted", failed: "Failed", unknown: "Status unknown", not_requested: "Not requested" };

export const AdminEmailSettings = () => {
  const [settings, setSettings] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => { axios.get(`${API}/admin/email-settings`).then(({ data }) => setSettings(data)).catch(() => setFailed(true)); }, []);
  return (
    <div className="flex flex-wrap items-start gap-3 border-b border-cream-muted pb-5 text-sm text-ragi-dark" data-testid="admin-email-settings">
      <Mail className="mt-1 h-4 w-4 shrink-0 text-terracotta" aria-hidden="true" />
      <div className="min-w-0">
        <p className="font-semibold" data-testid="admin-email-settings-status">{failed ? "Email settings unavailable" : settings ? settings.configured ? "Order emails enabled" : "Order emails not configured" : "Loading email settings…"}</p>
        {settings && <>
          <p className="mt-1 break-all text-xs text-muted-foreground" data-testid="admin-owner-email-recipient">Owner notifications: {settings.owner_recipient}</p>
          <p className="mt-1 break-words text-xs text-muted-foreground" data-testid="admin-email-sender">{settings.sender_name} · {settings.sending_address}</p>
          <p className="mt-1 break-all text-xs text-muted-foreground" data-testid="admin-email-reply-to">Reply-to: {settings.reply_to}</p>
        </>}
      </div>
    </div>
  );
};

export const AdminOrderEmails = ({ order, onUpdated }) => {
  const [busy, setBusy] = useState(false);
  const status = order.email_status;
  if (!status) return null;
  const canRetry = status.retryable;
  const retry = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/orders/${order.order_id}/retry-email`);
      onUpdated(data);
      if ([data.customer, data.owner].some((value) => ["failed", "unknown"].includes(value))) toast.error("Some emails could not be confirmed. Review their status.");
      else toast.success("Email status updated");
    } catch (err) { toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Could not retry order email"); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-2 text-xs text-muted-foreground" data-testid={`admin-email-status-${order.order_id}`}>
      <span data-testid={`admin-customer-email-${order.order_id}`}>Customer email: {LABELS[status.customer]}</span>
      <span data-testid={`admin-owner-email-${order.order_id}`}>Owner email: {LABELS[status.owner]}</span>
      {canRetry && <button type="button" disabled={busy} onClick={retry} title="Retry pending or rejected order emails" aria-label="Retry pending or rejected order emails" className="inline-flex items-center gap-1.5 rounded-full border border-ragi/20 px-3 py-1 text-ragi transition-colors hover:border-terracotta hover:text-terracotta disabled:opacity-50" data-testid={`admin-retry-email-${order.order_id}`}><RefreshCw className={`h-3 w-3 ${busy ? "animate-spin" : ""}`} />{busy ? "Retrying…" : "Retry email"}</button>}
    </div>
  );
};